import { useConnect } from '@lore/query-connect';

export default function useStoriesForUser(user, options = {}) {
  return useConnect('story.find', {
    where: {
      eager: {
        $where: {
          userNodes: {
            $where: {
              userId: user.id,
            }
          }
        }
      }
    },
    pagination: {
      page: options.page || 1,
      pageSize: options.pageSize || 3,
      order: 'createdAt desc'
    }
  });
};
